<div class="admin-page-container">
  <div class="admin-page-header">User Management</div>
  <div class="admin-page-body">
    <kendo-grid [data]="filteredItems"
                [skip]="skip"
                (edit)="editHandler($event)"
                (remove)="removeHandler($event)"
                (add)="addHandler($event)"
                (pageChange)="pageChange($event)"
                [pageable]="{
                  buttonCount:10,
                  info:true,
                  pageSizes:true,
                  previousNext:true,
                  responsive:true,
                  position: 'bottom'
              }"
                [pageSize]="pageSize"
                [style.height]="'100%'"
                [rowClass]="rowCallback">
      <ng-template kendoGridToolbarTemplate>
        <input placeholder="Search..."
               kendoTextBox
               (input)="onFilter($event.target)" type="search" />
        <kendo-grid-spacer></kendo-grid-spacer>
        <button kendoGridAddCommand type="button"><span class="fas fa-plus" title="Add New User"></span></button>
        <button kendoGridExcelCommand type="button" title="Export to Excel">
          <span class="fas fa-file-excel"></span>
        </button>
      </ng-template>
      <kendo-grid-column [hidden]="true" field="id" title="Id"></kendo-grid-column>
      <kendo-grid-column field="firstName" title="First Name"></kendo-grid-column>
      <kendo-grid-column field="lastName" title="Last Name"></kendo-grid-column>
      <kendo-grid-column field="alias" title="Alias"></kendo-grid-column>
      <kendo-grid-column field="email" title="Email Address"></kendo-grid-column>
      <kendo-grid-column field="companyId" title="Company">
        <ng-template kendoGridCellTemplate let-dataItem>
          {{ companyName(dataItem.companyId) }}
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-column field="isActive" title="Active" [width]="75">
        <ng-template kendoGridCellTemplate let-dataItem>
          <span [className]="checkBox(dataItem.isActive)"></span>
        </ng-template>
      </kendo-grid-column>
      <kendo-grid-command-column title="Action" [width]="100">
        <ng-template kendoGridCellTemplate let-isNew="isNew">
          <button kendoGridEditCommand [primary]="true" title="Edit User"><span class="far fa-pencil"></span></button>
          <button kendoGridRemoveCommand title="Delete User"><span class="far fa-trash-alt"></span></button>
        </ng-template>
      </kendo-grid-command-column>
      <kendo-grid-excel [fetchData]="allData" fileName="Users_Dump.xlsx"></kendo-grid-excel>
      <ng-template kendoPagerTemplate
                   let-totalPages="totalPages"
                   let-currentPage="currentPage">


        <div class="custom-pager">
          <div class="custom-pager-pagesize">View&nbsp;&nbsp; <kendo-dropdownlist [data]="sizes" [(ngModel)]="pageSize" (valueChange)="pageSizeChange($event)"></kendo-dropdownlist></div>
          <div class="custom-pager-jump"><kendo-pager-input></kendo-pager-input></div>
          <div class="custom-pager-items"><kendo-pager-prev-buttons></kendo-pager-prev-buttons> {{startnum()}} - {{endnum()}} of {{gridData.total}} <kendo-pager-next-buttons></kendo-pager-next-buttons></div>
        </div>
      </ng-template>
    </kendo-grid>

  </div>


</div>
